<template>
  <div class="expanded-overlay">
    <!-- Lijevo: tablica stavki -->
    <div class="expanded-table-zone">
      <div class="expanded-hdr">
        <span class="expanded-title">Košarica — detaljan prikaz</span>
        <button class="close-btn" @click="$emit('close')">
          <v-icon size="18">mdi-close</v-icon>
        </button>
      </div>
      <div class="expanded-table-wrap">
        <table class="items-table">
          <thead>
            <tr>
              <th>Naziv</th>
              <th class="ta-r">Kol.</th>
              <th class="ta-r">Cijena</th>
              <th class="ta-r">Popust</th>
              <th class="ta-r">Iznos</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, idx) in cart"
              :key="`${item.id}-${idx}`"
              class="item-row"
              @click="$emit('open-item-modal', idx)"
            >
              <td>{{ item.name }}</td>
              <td class="ta-r">{{ item.quantity }}</td>
              <td class="ta-r">{{ formatPrice(item.unitPrice != null ? item.unitPrice : item.price) }}</td>
              <td class="ta-r">{{ item.discount ? item.discount.rate + '%' : '−' }}</td>
              <td class="ta-r fw7 teal">{{ formatPrice(item.total) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Desno: ShopCart -->
    <shop-cart
      :cart="cart"
      :customer="customer"
      :discount="discount"
      :payment-method="paymentMethod"
      :currency="currency"
      :creating-receipt="creatingReceipt"
      @open-item-modal="i => $emit('open-item-modal', i)"
      @expand="$emit('close')"
      @open-customer-panel="$emit('open-customer-panel')"
      @open-discount-modal="$emit('open-discount-modal')"
      @open-note-modal="$emit('open-note-modal')"
      @clear-cart="$emit('clear-cart')"
      @create-receipt="$emit('create-receipt')"
      @update:paymentMethod="v => $emit('update:paymentMethod', v)"
    />
  </div>
</template>

<script>
import ShopCart from './ShopCart.vue'

export default {
  name: 'ShopCartExpanded',
  components: { ShopCart },
  props: {
    cart: { type: Array, default: () => [] },
    customer: { type: Object, default: null },
    discount: { type: Object, default: null },
    paymentMethod: { type: String, default: 'G' },
    currency: { type: String, default: 'EUR' },
    creatingReceipt: { type: Boolean, default: false }
  },
  methods: {
    formatPrice (cents) {
      if (!cents && cents !== 0) return '0,00 €'
      return (cents / 100).toFixed(2).replace('.', ',') + ' €'
    }
  }
}
</script>

<style scoped>
.expanded-overlay {
  display: flex;
  flex: 1;
  overflow: hidden;
  background: #F8FAFC;
  height: 100%;
}
.expanded-table-zone {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
  border-right: 1px solid rgba(0,0,0,0.06);
}
.expanded-hdr {
  height: 50px; padding: 0 16px;
  border-bottom: 1px solid rgba(0,0,0,0.06);
  display: flex; align-items: center; gap: 8px; flex-shrink: 0;
}
.expanded-title { flex: 1; font-size: 13px; font-weight: 700; color: #2d3748; }
.close-btn { background: transparent; border: none; cursor: pointer; color: #B0BEC5; border-radius: 6px; padding: 4px; display: flex; align-items: center; }
.close-btn:hover { background: #F8FAFC; color: rgba(70,70,80,0.9); }
.expanded-table-wrap { flex: 1; overflow-y: auto; padding: 12px; }
.items-table { width: 100%; border-collapse: collapse; }
.items-table thead th { font-size: 11px; font-weight: 700; color: #2d3748; text-transform: uppercase; letter-spacing: 0.8px; padding: 8px 10px; border-bottom: 2px solid #EDF2F7; background: #F8FAFC; }
.item-row td { padding: 10px; font-size: 12px; color: rgba(70,70,80,0.9); border-bottom: 1px solid #EDF2F7; cursor: pointer; }
.item-row:hover td { background: #F7FAFC; }
.ta-r { text-align: right; }
.fw7 { font-weight: 700; }
.teal { color: #00BCD4; }
</style>
